import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className='footer'>&#169; 2024 Khin Thandar Kyaw</div>
  )
};

export default Footer;